import { IStudentInfoSlice } from "../../../models/student/studentAcademicProfile";
import { createSlice } from "@reduxjs/toolkit";

const initialStudentInfoState: IStudentInfoSlice = {
    studentInfo: undefined,
  };
  
  const studentInfoSlice = createSlice({
    name: "studentInfo",
    initialState: initialStudentInfoState,
    reducers: {
      setStudentInfo: (state, action: { payload: any }) => {
        state.studentInfo = action.payload;
      },
    },
  });
  
  export const { setStudentInfo } = studentInfoSlice.actions;
  
  const studentInfoReducer = studentInfoSlice.reducer;
  
  export type studentInfoState = ReturnType<typeof studentInfoReducer>;
  
  export default studentInfoReducer;